
const BASE_URL = ENV_DEV ? "https://user.t.quanmaikeji.com" : "https://user.quanmaikeji.com";
const HWEB_URL = ENV_DEV ? "https://h5.t.quanmaikeji.com" : "https://h5.quanmaikeji.com";
const WEB_SHOP_URL = ENV_DEV ? "https://agency-shop.t.quanmaikeji.com" : "https://agency-shop.quanmaikeji.com";
const  SHOP_URL= ENV_DEV ? "https://agency-shop.t.quanmaikeji.com" : "https://agency-shop.quanmaikeji.com";
const YZL_URL = ENV_DEV ? "https://insurance.t.quanmaikeji.com" : "https://insurance.quanmaikeji.com";
export default {
    BASE_URL,
    HWEB_URL,
    SHOP_URL,
    WEB_SHOP_URL,
    YZL_URL
}
//token 临时票据


// WEBPACK FOOTER //
// ./src/service/params.js